/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable indent */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { IAttachment } from 'interfaces/component.interface';
import { renderTextWithLinksAndEmojis } from './utils';
import Attachment from './components/Attachment';

interface FirstBubbleProps {
  message: string;
  isAgent: boolean;
  isSender: boolean;
  attachment?: IAttachment;
  textHighlighter?: string;
  isSample?: boolean;
}

function FirstBubble(props: FirstBubbleProps) {
  const { message, isAgent, isSender, attachment, textHighlighter, isSample = false } = props;

  return (
    <div className={`m-1 max-w-sm ${isSender ? 'flex justify-end' : 'flex justify-start'}`}>
      <div
        className={classNames(
          `text-sm ${
            isAgent
              ? `bg-[#C4E5B6] p-3 max-w-fit ${
                  isSender
                    ? 'rounded-tl-2xl rounded-bl-2xl rounded-br-2xl'
                    : 'rounded-tr-xl rounded-bl-2xl rounded-br-2xl'
                }  border border-chineseSilver`
              : `bg-white p-3 max-w-fit ${
                  isSender
                    ? 'rounded-tl-2xl rounded-bl-2xl rounded-br-2xl'
                    : 'rounded-tr-xl rounded-bl-2xl rounded-br-2xl'
                } border border-chineseSilver`
          }`,
          {
            'min-h-[80px] min-w-[250px]': isSample,
          },
        )}
      >
        {attachment ? (
          <>
            {attachment.mimetype === 'application/pdf' ? (
              <Attachment
                message={message}
                attachment={attachment}
                textHighlighter={textHighlighter}
              />
            ) : (
              <a href={attachment.location} target="blank">
                <img className="cursor-pointer" src={attachment?.location} alt="Attachment" />
              </a>
            )}
          </>
        ) : (
          <span className={textHighlighter}>{renderTextWithLinksAndEmojis(message)}</span>
        )}
      </div>
    </div>
  );
}

FirstBubble.propTypes = {
  message: PropTypes.string,
  isAgent: PropTypes.bool,
  isSender: PropTypes.bool,
  attachment: PropTypes.any,
  textHighlighter: PropTypes.string,
  isSample: PropTypes.bool,
};

export default FirstBubble;
